import { render, staticRenderFns } from "./IconReport.vue?vue&type=template&id=97f9a3b8"
import script from "./IconReport.vue?vue&type=script&lang=js"
export * from "./IconReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports